<div class="modal-background" bdFxLayoutAlign="center start">
    <div class="projects-modal">
        <div class="header">
            <div class="title">
                Achtung
            </div>
            <div class="save">
                <bd-fa-button [name]="'times'" (click)="onCancelBtnClicked()"></bd-fa-button>
            </div>
        </div>

        <div class="body" [ngClass]="{'highlight' : errMessage}" [innerHTML]=" message ? message : errMessage">
        </div>

        <div class="footer">
            <button class="pr-btn active" type="button" (click)="onConfirmBtnClicked()" #focusedButton>
                Ok
            </button>
        </div>
    </div>
</div>
